(function () {
  'use strict';

  const MAX_PRODUCTS = 500;

  function normalizeProduct(value, origin) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    const id = String(value.id || '');
    const handle = typeof value.handle === 'string' ? value.handle : '';
    const title = typeof value.title === 'string' ? value.title.trim().slice(0, 300) : '';
    if (!/^[1-9]\d{0,23}$/.test(id) || !/^[a-z0-9][a-z0-9_-]{0,199}$/i.test(handle) || !title) return null;

    let url;
    try {
      const parsed = new URL(typeof value.url === 'string' ? value.url : '', origin);
      if (!/^https?:$/.test(parsed.protocol) || parsed.origin !== origin || !/\/products\/[^/]+\/?$/.test(parsed.pathname)) return null;
      parsed.hash = '';
      url = parsed.href;
    } catch (_) {
      return null;
    }

    let image = '';
    if (typeof value.image === 'string' && value.image) {
      try {
        const parsed = new URL(value.image, origin);
        const isShopifyCDN = parsed.hostname === 'cdn.shopify.com' || parsed.hostname.endsWith('.shopify.com');
        if (/^https?:$/.test(parsed.protocol) && (parsed.origin === origin || isShopifyCDN)) image = parsed.href;
      } catch (_) { /* A product without an image still belongs in the list. */ }
    }

    return {
      id: id,
      handle: handle,
      url: url,
      title: title,
      image: image,
      price: typeof value.price === 'string' ? value.price.slice(0, 100) : ''
    };
  }

  function parseProducts(raw, origin) {
    if (typeof raw !== 'string' || raw.length > 2000000) return [];
    let parsed;
    try { parsed = JSON.parse(raw); } catch (_) { return []; }
    if (!Array.isArray(parsed)) return [];
    const seen = new Set();
    const products = [];
    for (const value of parsed) {
      const product = normalizeProduct(value, origin);
      if (product && !seen.has(product.id)) {
        seen.add(product.id);
        products.push(product);
        if (products.length === MAX_PRODUCTS) break;
      }
    }
    return products;
  }

  function toggleProduct(products, product) {
    const exists = products.some(function (item) { return item.id === product.id; });
    return exists
      ? products.filter(function (item) { return item.id !== product.id; })
      : [product].concat(products).slice(0, MAX_PRODUCTS);
  }

  // These pure functions also permit local verification without a browser.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeProduct: normalizeProduct, parseProducts: parseProducts, toggleProduct: toggleProduct };
    return;
  }
  if (typeof document === 'undefined') return;

  function initialize() {
    const panel = document.querySelector('[data-favorites-panel]');
    if (!panel) return;
    const list = panel.querySelector('[data-favorites-list]');
    const empty = panel.querySelector('[data-favorites-empty]');
    const note = panel.querySelector('[data-favorites-note]');
    const announcement = document.querySelector('[data-favorites-announcement]');
    const origin = window.location.origin;
    const shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : window.location.hostname;
    const storageKey = 'theme-favorites:v1:' + shop;
    const desktopMedia = window.matchMedia('(min-width: 990px)');
    let persistent = true;
    let products = [];
    let opener = null;
    let announcementTimer;
    let refreshScheduled = false;

    try { products = parseProducts(window.localStorage.getItem(storageKey), origin); }
    catch (_) { persistent = false; }

    function announce(message) {
      if (!announcement) return;
      window.clearTimeout(announcementTimer);
      announcement.textContent = '';
      announcementTimer = window.setTimeout(function () {
        announcement.textContent = message + (persistent ? '' : ' Favoris enregistrés pour cette visite.');
      }, 30);
    }

    function updateNote() {
      if (note) note.textContent = persistent
        ? 'Vos favoris sont enregistrés dans ce navigateur.'
        : 'Favoris enregistrés pour cette visite. Le stockage de votre navigateur est indisponible.';
    }

    function saveProducts() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(products));
        persistent = true;
      } catch (_) { persistent = false; }
      updateNote();
    }

    function syncButtons() {
      const ids = new Set(products.map(function (item) { return item.id; }));
      document.querySelectorAll('[data-favorite-toggle]').forEach(function (button) {
        const selected = ids.has(button.dataset.productId);
        const action = selected ? 'Retirer des favoris' : 'Ajouter aux favoris';
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', action + ' : ' + (button.dataset.productTitle || 'ce produit'));
        const label = button.querySelector('[data-favorite-label]');
        if (label && label.textContent !== action) label.textContent = action;
      });
      document.querySelectorAll('[data-favorites-count]').forEach(function (count) {
        const value = String(products.length);
        if (count.textContent !== value) count.textContent = value;
        count.hidden = products.length === 0;
      });
    }

    function makeHeart() {
      const template = empty && empty.querySelector('.icon-favorite');
      return template ? template.cloneNode(true) : document.createElement('span');
    }

    function makeRemoveIcon() {
      const closeIcon = panel.querySelector('[data-favorites-close] svg');
      return closeIcon ? closeIcon.cloneNode(true) : document.createTextNode('×');
    }

    function renderPanel() {
      if (!list || !empty) return;
      const focused = document.activeElement;
      const focusedId = focused && focused.dataset ? focused.dataset.favoriteRemove : null;
      const previousButtons = Array.from(list.querySelectorAll('[data-favorite-remove]'));
      const focusedIndex = previousButtons.indexOf(focused);
      const fragment = document.createDocumentFragment();
      products.forEach(function (product) {
        const item = document.createElement('li');
        item.className = 'theme-favorites-panel__item';

        const imageLink = document.createElement('a');
        imageLink.className = 'theme-favorites-panel__image-link';
        imageLink.href = product.url;
        imageLink.setAttribute('aria-label', product.title);
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.width = 88;
          image.height = 110;
          image.loading = 'lazy';
          image.addEventListener('error', function () { image.replaceWith(makeHeart()); }, { once: true });
          imageLink.appendChild(image);
        } else { imageLink.appendChild(makeHeart()); }

        const info = document.createElement('div');
        const title = document.createElement('h3');
        title.className = 'theme-favorites-panel__product-title';
        const titleLink = document.createElement('a');
        titleLink.href = product.url;
        titleLink.textContent = product.title;
        title.appendChild(titleLink);
        const view = document.createElement('a');
        view.className = 'theme-favorites-panel__view';
        view.href = product.url;
        view.textContent = 'Voir le produit';
        info.append(title, view);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'theme-favorites-panel__remove';
        remove.dataset.favoriteRemove = product.id;
        remove.setAttribute('aria-label', 'Retirer des favoris : ' + product.title);
        remove.appendChild(makeRemoveIcon());
        item.append(imageLink, info, remove);
        fragment.appendChild(item);
      });
      list.replaceChildren(fragment);
      list.hidden = products.length === 0;
      empty.hidden = products.length !== 0;
      if (focusedId && panel.open) {
        const buttons = Array.from(list.querySelectorAll('[data-favorite-remove]'));
        const nextFocus = buttons.find(function (button) { return button.dataset.favoriteRemove === focusedId; })
          || buttons[Math.min(Math.max(focusedIndex, 0), buttons.length - 1)]
          || panel.querySelector('[data-favorites-close]');
        if (nextFocus) nextFocus.focus();
      }
    }

    function refresh() {
      syncButtons();
      if (panel.open) renderPanel();
    }

    function openPanel(button) {
      if (!desktopMedia.matches || panel.open) return;
      opener = button;
      renderPanel();
      syncButtons();
      if (typeof panel.showModal === 'function') {
        panel.showModal();
        document.documentElement.classList.add('theme-favorites-open');
      } else {
        announce('Votre navigateur ne prend pas en charge l’affichage des favoris.');
      }
    }

    function closePanel() {
      if (panel.open) panel.close();
      document.documentElement.classList.remove('theme-favorites-open');
    }

    panel.addEventListener('close', function () {
      document.documentElement.classList.remove('theme-favorites-open');
      if (desktopMedia.matches && opener && opener.isConnected) opener.focus();
      opener = null;
    });

    function handleViewportChange() {
      if (desktopMedia.matches) {
        syncButtons();
        return;
      }
      // Closing the native dialog releases its modal focus and scroll lock.
      closePanel();
      window.clearTimeout(announcementTimer);
      if (announcement) announcement.textContent = '';
    }

    if (typeof desktopMedia.addEventListener === 'function') desktopMedia.addEventListener('change', handleViewportChange);
    else desktopMedia.addListener(handleViewportChange);

    panel.addEventListener('click', function (event) {
      if (event.target !== panel) return;
      const bounds = panel.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closePanel();
    });

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-favorite-toggle], [data-favorites-open], [data-favorites-close], [data-favorite-remove]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.hasAttribute('data-favorites-close')) { closePanel(); return; }
      if (!desktopMedia.matches) { closePanel(); return; }
      if (button.hasAttribute('data-favorites-open')) { openPanel(button); return; }

      if (button.hasAttribute('data-favorite-remove')) {
        const removed = products.find(function (item) { return item.id === button.dataset.favoriteRemove; });
        products = products.filter(function (item) { return item.id !== button.dataset.favoriteRemove; });
        saveProducts();
        refresh();
        if (removed) announce(removed.title + ' retiré des favoris.');
        return;
      }

      const product = normalizeProduct({
        id: button.dataset.productId,
        handle: button.dataset.productHandle,
        url: button.dataset.productUrl,
        title: button.dataset.productTitle,
        image: button.dataset.productImage,
        price: button.dataset.productPrice
      }, origin);
      if (!product) { announce('Ce produit ne peut pas être enregistré.'); return; }
      const wasSelected = products.some(function (item) { return item.id === product.id; });
      products = toggleProduct(products, product);
      saveProducts();
      refresh();
      announce(product.title + (wasSelected ? ' retiré des favoris.' : ' ajouté aux favoris.'));
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== storageKey && event.key !== null) return;
      products = parseProducts(event.newValue, origin);
      refresh();
    });

    document.addEventListener('shopify:section:load', syncButtons);
    // Collection filtering and editor reloads can insert new buttons after initialization.
    const observer = new MutationObserver(function (mutations) {
      if (refreshScheduled) return;
      const relevant = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-favorite-toggle], [data-favorites-count]') || node.querySelector('[data-favorite-toggle], [data-favorites-count]'));
        });
      });
      if (!relevant) return;
      refreshScheduled = true;
      window.requestAnimationFrame(function () { refreshScheduled = false; syncButtons(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    updateNote();
    syncButtons();
    handleViewportChange();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
}());
